var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 -0.000152588C3.58214 -0.000152588 0.000488281 3.5815 0.000488281 7.99968C0.000488281 12.4179 3.58214 15.9995 8.00033 15.9995C12.4185 15.9995 16.0002 12.4179 16.0002 7.99968C16.0002 3.5815 12.4185 -0.000152588 8.00033 -0.000152588ZM11.3535 6.35312C11.5487 6.15785 11.5487 5.84127 11.3535 5.64601C11.1582 5.45075 10.8416 5.45075 10.6464 5.64601L6.99999 9.29237L5.35358 7.64597C5.15832 7.45071 4.84174 7.45071 4.64648 7.64597C4.45121 7.84123 4.45121 8.15781 4.64648 8.35308L6.64643 10.353C6.8417 10.5483 7.15828 10.5483 7.35354 10.353L11.3535 6.35312Z",
    fill: "#00A832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrect);
export default __webpack_public_path__ + "static/media/icon-correct.91c1b8808792366aeab539a302024d3f.svg";
export { ForwardRef as ReactComponent };